<div class="modal-header">
  <h4 class="modal-title pull-left">Program</h4>
  <button type="button" class="btn-close close pull-right fs-12" aria-label="Close" (click)="cancel()">
    <span aria-hidden="true" class="visually-hidden font-weight-light">&times;</span>
  </button>
</div>
<div class="modal-body">
  <nz-spin [nzSpinning]="isLoading"></nz-spin>

  @if (!isLoading && item) {
    <strong>{{ item.title }}</strong>

    <div class="hr-separator"><hr></div>

    <div class="row">
      <div class="col col-lg-12">
        <table class="table table-borderless">
          <tr>
            <td class="fs-12 pt-1 pb-0 w-120">ID:</td>
            <td class="fs-12 pt-1 pb-0">{{ item.program }}</td>
          </tr>
          <tr>
            <td class="fs-12 pt-1 pb-0 w-120">Status:</td>
            <td class="fs-12 pt-1 pb-0">{{ item.status }}</td>
          </tr>

          @if (item.assurances) {
            <tr>
              <td colspan="2">
                @if (item.assurances.length > 0) {
                  <table class="table table-borderless mt-3 mb-3">
                    <tr>
                      <th>Activity Types:</th>
                      <th>Assurance Tasks:</th>
                    </tr>
                  @for (assurance of item.assurances; track assurance.activity_type + '-' + $index) {
                  <tr>
                    <td class="fs-12 pt-1 pb-0 ps-2 align-top">
                      {{ assurance.activity_type }}
                    </td>
                    <td class="fs-12 pt-1 pb-0 ps-2">
                      {{ assurance.task }} <br> {{ assurance.title }}
                    </td>
                  </tr>
                  }
                  </table>
                }
              </td>
            </tr>
          } @else {
            <tr>
              <td class="fs-12 pt-1 pb-0 w-120">Activity Type:</td>
              <td class="fs-12 pt-1 pb-0">{{ item.activity_type }}</td>
            </tr>
          }

          <tr>
            <td class="fs-12 pt-1 pb-0 w-120">Interval:</td>
            <td class="fs-12 pt-1 pb-0">{{ item.interval }}</td>
          </tr>
        </table>
      </div>

      <div class="w-100">
        <ul ngbNav #nav="ngbNav" [destroyOnHide]="false" class="nav-tabs">
          <!-- DESCRIPTION -->
          <li [ngbNavItem]="1">
            <a ngbNavLink class="text-dark font-weight-bold border-start-0 square-top-left-border">Description</a>
            <ng-template ngbNavContent>
              <div class="pt-3 px-3 pe-3 pb-0 mt-0 word-breaker">
                <span [innerHTML]="item.description | normalizeNewLines | newLineBreaker | nullAsWhatever : '-'"></span>
              </div>
            </ng-template>
          </li>
          <!-- DESCRIPTION -->

          <!-- EQUIPMENT TAG -->
          <li [ngbNavItem]="2">
            <a ngbNavLink class="text-dark font-weight-bold">Equipment Tag</a>
            <ng-template ngbNavContent>
              <div [ngClass]="{'pt-3 pe-3 px-3 pb-0 mt-0': true, 'scrollable-container': true}">
                @if (item.equipment_tags.length > 0) {
                  <table class="table table-borderless mb-0 transparent-head">
                    <thead>
                    <tr>
                      <th class="fs-12 pt-1 pb-1 px-0 pe-0 border-light">TagName</th>
                      <th class="fs-12 pt-1 pb-1 px-0 pe-0 border-light">Description</th>

                    </tr>
                    </thead>
                    <tbody>
                    @for (equipmentTag of item.equipment_tags; track equipmentTag.tag + '-' + $index) {
                      <tr>
                        <td class="fs-12 pt-1 pb-1 px-0 pe-0">
                          <span class="clickable" (click)="onDataCardDrawerOpen(equipmentTag.tag)">
                            {{ equipmentTag.tag }}
                          </span>
                        </td>
                        <td class="fs-12 pt-1 pb-1 px-0 pe-0">
                          {{ equipmentTag.description | normalizeNewLines | nullAsWhatever : '-' }}
                        </td>
                      </tr>
                    }
                    </tbody>
                  </table>
                }
              </div>
            </ng-template>
          </li>
          <!-- EQUIPMENT TAG -->
        </ul>
        <div [ngbNavOutlet]="nav" class="mt-0"></div>
      </div>
    </div>
  }
</div>
<div class="modal-footer text-center">
  <button type="button" class="btn btn-outline-danger" (click)="cancel()">
    Close
  </button>
</div>

